import { get } from '../request';
import { APP_CONFIG } from '@/config';
import { TenantNetworkStatus } from '@/@types/tenantNetwork';

export const getTenantNetworkStatus = async (): Promise<TenantNetworkStatus> => {
  return await get<TenantNetworkStatus>(`${APP_CONFIG.tenantNetworkApiUrl}/status`);
};
